import { render, staticRenderFns } from "./information-look.vue?vue&type=template&id=468f6964&scoped=true&"
import script from "./information-look.vue?vue&type=script&lang=js&"
export * from "./information-look.vue?vue&type=script&lang=js&"
import style0 from "./information-look.vue?vue&type=style&index=0&id=468f6964&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f6964",
  null
  
)

export default component.exports